module.exports = __webpack_public_path__ + "img/1722485785109-WhatsApp Image 2024-08-01 at 10.42.33.jpeg.5d3a514c.webp";